import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { ReportOrganizationType } from '../../entities/report-organization-type';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class ReportOrganizationTypeService {

  private static readonly reportOrganizationTypeBaseUrl:string = `${Settings.apiUrl}/v1/ReportOrganizationTypes`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getReportOrganizationTypes(): Promise<ReportOrganizationType[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(ReportOrganizationTypeService.reportOrganizationTypeBaseUrl);

    oDataBuilder
      .orderBy("Name");

    let reportSubCategoryUrl: string = oDataBuilder.toString();

    return this.http.get(reportSubCategoryUrl)
      .toPromise()
      .then(response => response.json().value);

  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/report-organization-type.service.ts